import { Tag as AntTag } from 'antd'
import styled from 'styled-components'
import { TagSize, TagVariant } from './Tag'
import { theme } from '@/app/styles/theme'

export const StyledTag = styled(AntTag).withConfig({
  shouldForwardProp: (prop) => !['variant', 'size', 'isClicked'].includes(prop),
})<{
  variant: TagVariant
  size: TagSize
  isClicked: boolean
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  font-weight: 600;
  border: 1px solid;
  transition: all 0.2s ease-in-out;
  background: transparent;
  margin: 0;

  ${(props) =>
    props.size === 'medium' &&
    `
    height: 20px;
    padding: 0 8px;
    font-size: 14px;
    line-height: 20px;
  `}

  ${(props) =>
    props.size === 'large' &&
    `
    height: 28px;
    padding: 0 12px;
    font-size: 14px;
    line-height: 20px;
  `}

  ${(props) =>
    props.variant === 'default' &&
    `
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: #000000;
  `}

  ${(props) =>
    props.variant === 'primary' &&
    `
    background-color: #1677ff;
    color: #ffffff;
  `}
  
  ${(props) =>
    props.variant === 'secondary' &&
    `
    background-color: #fafafa;
    border-color: #d9d9d9;
    color: #666666;
  `}
  
  ${(props) =>
    props.variant === 'accent' &&
    `
    color: ${props.theme.colors.tag.accent};
  `}
  ${(props) =>
    props.variant === 'created' &&
    `
    color: ${props.theme.colors.tag.created};
  `}
  ${(props) =>
    props.variant === 'processed' &&
    `
    color: ${props.theme.colors.tag.processed};
  `}
  ${(props) =>
    props.variant === 'success' &&
    `
    background-color: #52c41a;
    color: #ffffff;
  `}
  
  ${(props) =>
    props.variant === 'attention' &&
    `
    color: ${props.theme.colors.tag.warning};
  `}
  
  ${(props) =>
    props.variant === 'deleted' &&
    `
    color: ${props.theme.colors.tag.deleted};
  `}
  ${(props) =>
    props.variant === 'severe' &&
    `
    background-color: #fa541c;
    color: #ffffff;
  `}
  
  ${(props) =>
    props.variant === 'danger' &&
    `
    color: ${props.theme.colors.tag.error};
  `}
  
  ${(props) =>
    props.variant === 'done' &&
    `
    color: ${props.theme.colors.success};

  `}
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};

  ${(props) =>
    props.onClick &&
    `
    &:hover {
      box-shadow: inset 0 0 0 1px ${props.theme.colors.primary};
      border-color: ${props.theme.colors.primary};
    }
  `}

  ${(props) =>
    props.isClicked &&
    `
    background-color: ${getBorderColor(props.variant)};
    color: white;
  `}
`
const getBorderColor = (variant: TagVariant): string => {
  const colors = {
    default: theme.colors.primary,
    primary: theme.colors.primary,
    secondary: '#6c757d',
    accent: theme.colors.primary,
    success: theme.colors.success,
    attention: theme.colors.tag.warning,
    severe: '#fa541c',
    danger: theme.colors.tag.error,
    done: theme.colors.success,
    created: theme.colors.tag.created,
    processed: theme.colors.tag.processed,
    warning: theme.colors.tag.warning,
    deleted: theme.colors.tag.deleted,
  }
  return colors[variant] || colors.default
}
